(() => {
  const initializeHero = (hero) => {
    if (hero.dataset.videoControlInitialized === 'true') {
      return;
    }

    const video = hero.querySelector('[data-fk-home-hero-video]');
    const control = hero.querySelector('[data-fk-home-hero-video-control]');
    const soundControl = hero.querySelector('[data-fk-home-hero-sound-control]');

    if (!video || !control || !soundControl) {
      return;
    }

    const playIcon = control.querySelector('[data-video-icon="play"]');
    const pauseIcon = control.querySelector('[data-video-icon="pause"]');
    const playLabel = control.dataset.playLabel;
    const pauseLabel = control.dataset.pauseLabel;
    const mutedIcon = soundControl.querySelector('[data-sound-icon="muted"]');
    const audibleIcon = soundControl.querySelector('[data-sound-icon="audible"]');
    const enableSoundLabel = soundControl.dataset.enableSoundLabel;
    const muteLabel = soundControl.dataset.muteLabel;

    const updateControl = () => {
      const isPaused = video.paused;
      control.setAttribute('aria-label', isPaused ? playLabel : pauseLabel);
      playIcon.toggleAttribute('hidden', !isPaused);
      pauseIcon.toggleAttribute('hidden', isPaused);
    };

    const updateSoundControl = () => {
      const isMuted = video.muted;
      soundControl.setAttribute('aria-label', isMuted ? enableSoundLabel : muteLabel);
      mutedIcon.toggleAttribute('hidden', !isMuted);
      audibleIcon.toggleAttribute('hidden', isMuted);
    };

    control.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(updateControl);
      } else {
        video.pause();
      }
    });

    soundControl.addEventListener('click', () => {
      video.muted = !video.muted;
    });

    video.addEventListener('play', updateControl);
    video.addEventListener('pause', updateControl);
    video.addEventListener('volumechange', updateSoundControl);
    updateControl();
    updateSoundControl();
    hero.dataset.videoControlInitialized = 'true';
  };

  const initializeHeroes = (container = document) => {
    container.querySelectorAll('[data-fk-home-hero]').forEach(initializeHero);
  };

  initializeHeroes();
  document.addEventListener('shopify:section:load', (event) => initializeHeroes(event.target));
})();
